import { css } from '@emotion/react'
import { useCallback, type ReactNode } from 'react'
import {
  DesignToken,
  Icon,
  ListItem,
  RadiusToken,
  SpacingToken,
} from '@livechat/design-system-react-components'
import { Check } from '@livechat/design-system-icons'

const listItemCss = css`
  border-radius: var(${RadiusToken.Radius3});
  padding: 6px 11px;

  :hover {
    background-color: var(${DesignToken.SurfacePrimaryHover});
    cursor: pointer;
  }

  > div {
    padding-right: var(
      ${SpacingToken.Spacing7}
    ); // Empty space for check icon + margin
  }
`

const selectedCss = css`
  color: var(${DesignToken.ActionPrimaryActive});
  background-color: var(${DesignToken.SurfacePrimaryActive});

  > div {
    padding-right: 0;
  }
`

interface Props {
  isSelected: boolean
  isFocused: boolean
  content: ReactNode
  itemId: string
  onItemSelect: (itemId: string) => void
}

const FilterItem = ({ isSelected, content, itemId, onItemSelect }: Props) => {
  const onClick = useCallback(
    () => onItemSelect(itemId),
    [itemId, onItemSelect]
  )

  return (
    <div
      css={[listItemCss, isSelected && selectedCss]}
      onClick={onClick}
      data-test={`filter-list-item-${itemId}`}
    >
      <ListItem rightNode={isSelected && <Icon source={Check} />}>
        {content}
      </ListItem>
    </div>
  )
}

export default FilterItem
